import React, { useState } from 'react';
import EmojiContainer from '../../../../components/emojis/emojis';
import { WbMarkdownHtml } from '../../../../utils/common';
import './style.scss';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import CKEDITOR from '@workboard/ckeditor5-build-wobo';
import KRService from '../../../services/kr.service';
import { useRbrSliderPortalContainer } from '../../../../rbr/components/slider-portal';

const krService = new KRService();
const SimpleEditor = ({
    onChange,
    onChangeEmoji,
    text,
    placeHolder = '',
    id = '',
    readOnly = false,
    focusEditor = () => { },
    blurEditor = () => { },
    mentionFeature = true,
    dynamicRender = false,
    focusOnInit = false,
    excludeAIAgents = true
}) => {
    const slideshowWrapper = useRbrSliderPortalContainer();
    const textVal = (text == undefined || text == null) ? '' : text;
    const editorId = `simple-editor-${id}`;
    const [ck_editor, setEditor] = useState(null);
    const [initilize, initilizeEditor] = useState(false);
    const getFeedItems = async (queryText) => {
        return await krService.getUserAndTeamData({ 'term': queryText, 'viaAI': true, 'excludeAIAgents': excludeAIAgents, 'includeOwnAgents': true }).then((response: any) => {
            response.data.map((items) => {
                items["id"] = `@${items["label"]}`;
                items["userId"] = items["value"];
                items["link"] = wbConfig.baseDomainUrl + '/memberProfile/index?id=' + items['value'];
                if (items.isTeamSearch) {
                    items["link"] = wbConfig.baseDomainUrl + '/activity/workstreams?teamId=' + items['value'] + '&teamView&selectedTab=showTeam';
                }
            });
            return response.data;
        }).catch((err: any) => {
            console.log('err', err);
        });
    }

    const customItemRenderer = (item) => {
        const itemElement = document.createElement('li');
        itemElement.classList.add('mention-suggestions-li');

        if (!item.isTeamSearch) {
            itemElement.innerHTML = '<span class="pR5"><img class="fitProfileImage roundFramePhoto goalMentionsImg" src="' + item.picSrc + '" /><span style="padding-left: 5px;">' + item.label + '</span>';
        } else {
            itemElement.innerHTML = '<span class="pR5"><img class="fitProfileImage roundFramePhoto goalMentionsImg" src="../images/icons/menu/topnavigation/teams_new.png" /><span style="padding-left: 5px;">' + item.label + '</span>';
        }

        return itemElement;
    }

    function MentionCustomization(editor) {
        // The upcast converter will convert <a class="mention" href="" data-user-id="">
        // elements to the model 'mention' attribute.
        editor.conversion.for('upcast').elementToAttribute({
            view: {
                name: 'a',
                key: 'data-mention',
                classes: 'mention',
                attributes: {
                    'data-user-id': true,
                    "href": true
                }
            },
            model: {
                key: 'mention',
                value: viewItem => {
                    // The mention feature expects that the mention attribute value
                    // in the model is a plain object with a set of additional attributes.
                    // In order to create a proper object, use the toMentionAttribute helper method:
                    const mentionAttribute = editor.plugins.get('Mention').toMentionAttribute(viewItem, {
                        // Add any other properties that you need.
                        userId: viewItem.getAttribute('data-user-id'),
                        link: viewItem.getAttribute('href'),
                        'target': "_blank"
                    });

                    return mentionAttribute;
                }
            },
            converterPriority: 'high'
        });

        // Downcast the model 'mention' text attribute to a view <a> element.
        editor.conversion.for('downcast').attributeToElement({
            model: 'mention',
            view: (modelAttributeValue, { writer }) => {
                // Do not convert empty attributes (lack of value means no mention).
                if (!modelAttributeValue) {
                    return;
                }
                const className = modelAttributeValue.link.indexOf("workstreams") === -1 ? `selectedUser mention ${modelAttributeValue.userId}` : `selectedTeam mention ${modelAttributeValue.userId}`;
                return writer.createAttributeElement('a', {
                    class: className,
                    'data-mention': modelAttributeValue.id,
                    'data-user-id': modelAttributeValue.userId,
                    'href': modelAttributeValue.link,
                    'target': "_blank"
                }, {
                    // Make mention attribute to be wrapped by other attribute elements.
                    priority: 20,
                    // Prevent merging mentions together.
                    id: modelAttributeValue.uid
                });
            },
            converterPriority: 'high'
        });
    }

    const iniEditor = (editorId) => {
        !readOnly && initilizeEditor(true);
    }

    return (
        <div
            className="simple-editor-wrapper"
            id={editorId}
            onMouseEnter={() => iniEditor(id)}
            onMouseLeave={() => iniEditor(id)}
            onClick={() => iniEditor(id)}
        >
            {readOnly || (!initilize && dynamicRender) ?
            <div
                className={"simple-editor" + (readOnly ? " simple-editor-readonly" : "")}
                data-placeholder={placeHolder}
                dangerouslySetInnerHTML={WbMarkdownHtml(textVal)}
                onMouseEnter={() => iniEditor(id)}
                onMouseLeave={() => iniEditor(id)}
                onClick={() => iniEditor(id)}
            /> : <CKEditor
                editor={CKEDITOR.BalloonEditor}
                data={(textVal)}
                id={editorId}
                config={{
                    licenseKey: ckeditorLicenseKey,
                    placeholder: placeHolder,
                    toolbar: {
                        items: ['bold', 'italic', 'underline', 'strikethrough', 'link', 'bulletedList', 'numberedList', 'horizontalLine', 'undo']
                    },
                    plugins: [...CKEDITOR.BalloonEditor.builtinPlugins, MentionCustomization],
                    ...(mentionFeature && {
                        mention: {
                            feeds: [
                                {
                                    marker: '@',
                                    feed: getFeedItems,
                                    itemRenderer: customItemRenderer
                                }
                            ]
                        }
                    })
                }}
                onChange={(event, editor) => {
                    onChange(editor);
                }}
                onReady={editor => {
                    const body = editor?.ui.view.body._bodyCollectionContainer;
                    if (body && slideshowWrapper) {
                        body.remove();
                        slideshowWrapper.appendChild(body);
                    }
                    setEditor(editor);
                }}
                onFocus={focusEditor}
                onBlur={blurEditor}
            />
            }
        </div>
    )
}

export default SimpleEditor;
